import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store';

export interface LogoSettings {
  alt?: string;
  type?: string;
  logoText?: string;
}

export interface DataSourceItem {
  title: string;
  key: string;
}

const emptyDashboardSettings = {
  menuItems: [],
  logoSettings: null,
  dataSource: [],
};

export const useDashboardTopBar = () => {
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const dashboardTopBarSettings =
    selectedTenancy?.features?.dashboardTopBarSettings ||
    emptyDashboardSettings;

  const menuItems = useMemo(() => {
    if (Array.isArray(dashboardTopBarSettings.menuItems)) {
      // deep copy as sort will affect original array
      const menuItems = JSON.parse(
        JSON.stringify(dashboardTopBarSettings.menuItems),
      );
      return menuItems.sort((a: any, b: any) => a?.order - b?.order);
    }
    return [];
  }, [selectedTenancy]);

  const logoSettings: LogoSettings | null = useMemo(
    () => dashboardTopBarSettings.logoSettings || null,
    [selectedTenancy],
  );

  const dataSource: DataSourceItem[] = useMemo(
    () =>
      Array.isArray(dashboardTopBarSettings.dataSource)
        ? dashboardTopBarSettings.dataSource
        : [],
    [selectedTenancy],
  );

  const lastImportBySource = selectedTenancy?.lastImportBySource || {};

  const showCustomisedNavbar = menuItems?.length > 0;

  return {
    showCustomisedNavbar,
    menuItems,
    logoSettings,
    dataSource,
    lastImportBySource,
  };
};
